import React from "react";
import ReactInfiniteScroll from "react-infinite-scroll-component";
import Loader from "../Loader";

const InfiniteScroll = ({
  totalItems,
  fetchMore,
  hasMore,
  children,
  hideLoader,
  ...props
}) => {
  return (
    <ReactInfiniteScroll
      dataLength={totalItems} //This is important field to render the next data
      next={fetchMore}
      hasMore={hasMore}
      loader={!hideLoader && <Loader hideOverlay isStack isDark />}
      pullDownToRefreshThreshold={80}
      {...props}
    >
      {children}
    </ReactInfiniteScroll>
  );
};

export default InfiniteScroll;
